$(document).on('click','.button-1:eq(1)',function(){
  window.dataLayer.push({
    "event": 'Category_event',
    "event_category": 'Unlock Plenty of Cleanmas Magic',
    "event_label":'Start Earning'
    })
    window.location.href ="https://www.dreametech.com/pages/dreame-membership";
    //$(document).find('.wlo_pulltab').trigger('click');
  })



$(".active-link").click(function(){
let title=$(this).parent()?.find("div")?.find('.active-left_text')?.text()?.trim()??'';

window.dataLayer.push({
"event": 'Navigation_event',
"event_category": 'Header Tertiary Navigation',
"event_label":title+" See All"
});

})
$(document).on('click','li[data-name="halloween-sale"] a',function(){

window.dataLayer.push({
"event": 'Navigation_event',
"event_category": 'Header Primary  Navigation',
"event_label":$(this)?.find('span')?.text()?.trim()??''
});

})

document.addEventListener('input', function(event) {
if (event.target.matches('input.ajaxcart__qty-num')) {
let num=parseInt(event.target.value);
console.log(num);
let remDom=event.target?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement.parentElement??document.body;
let remPrice=remDom?.querySelector(".upcart-item-price")?.textContent?.replace(/[$,]/g, '')??0;
let remNum=1;

window.dataLayer.push({
"event": 'Public_event',
"event_category": 'Cart Popup Component',
"event_label":'Mod Product Number'
});

  if(num<1){
window.dataLayer.push({
"event": 'Public_event',
"event_category": 'Cart Popup Component',
"event_label":'Delete Product'
});

let rem_cart_product=[];
rem_cart_product.push({
"item_id":(remDom?.getAttribute('id')?.split(":")[0])?.toString()??'',
"item_name":remDom?.querySelector(".upcart-product-title-link")?.textContent??'',
"item_category":getProductClass(remDom?.querySelector(".upcart-product-title-link")?.textContent??''),
"item_brand":"dreame",
"price":parseFloat(remPrice/remNum)?.toFixed(2)??0,
"index":0,
"quantity":1
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
event: 'remove_to_cart',
ecommerce:{
"currency":'USD',
"value":parseFloat(remPrice/remNum).toFixed(2),
"items":rem_cart_product
}
});
  }

}
});


document.addEventListener('input', function(event) {
if (event.target.matches('input.js-qty__num')) {
let num=parseInt(event.target.value);
// console.log(num);
let remDom=event.target?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement.parentElement??document.body;
let remPrice=remDom?.querySelector(".upcart-item-price")?.textContent?.replace(/[$,]/g, '')??0;
let remNum=1;

window.dataLayer.push({
"event": 'Public_event',
"event_category": 'Cart Popup Component',
"event_label":'Mod Product Number'
});

  if(num<1){
window.dataLayer.push({
"event": 'Public_event',
"event_category": 'Cart Popup Component',
"event_label":'Delete Product'
});

let rem_cart_product=[];
rem_cart_product.push({
"item_id":(remDom?.getAttribute('id')?.split(":")[0])?.toString()??'',
"item_name":remDom?.querySelector(".upcart-product-title-link")?.textContent??'',
"item_category":getProductClass(remDom?.querySelector(".upcart-product-title-link")?.textContent??''),
"item_brand":"dreame",
"price":parseFloat(remPrice/remNum)?.toFixed(2)??0,
"index":0,
"quantity":1
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
event: 'remove_to_cart',
ecommerce:{
"currency":'USD',
"value":parseFloat(remPrice/remNum).toFixed(2),
"items":rem_cart_product
}
});
  }

}
});




$(document).ready(function(){
let pagesUrl=window.location.href;
if(pagesUrl.indexOf("/pages/dreame-contact-us") !== -1){

$(document).on('click',".text-link",function(){

if($(this).parent('p').length>0){

let contents = $(this).parent('p')?.contents()??[];

 let title = contents.filter(function() {
return this.nodeType === 3; 
})?.text()?.trim()?.replace(/:/g, '')??'';

window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Email Inquiry',
      "event_label":title
      });

}

})

}



if(pagesUrl.indexOf("/pages/partnership-application") !== -1){
  $(".join-us-btn").click(function(){

window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Become a Partner',
      "event_label":'Join Us'
      });

  })


 $(document).on('blur','div[data-id="19045"] input',function(){
  let labelTitle=$(this).parent()?.parent()?.find('label')?.find('span')?.eq(0)?.text()?.trim()??'';
  
window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Registration Procedure Input',
      "event_label":labelTitle
      });

 })


 $(document).on('blur','div[data-id="19045"] textarea',function(){
  let labelTitle=$(this).closest(".globo-form-control")?.find('label')?.find('span')?.eq(0)?.text()?.trim()??'';
  window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Registration Procedure Input',
      "event_label":labelTitle
      }); 
 })



$(document).on('change','div[data-id="19045"] .checkbox-input',function(){
  if($(this).is(':checked')){
let dom=$(this).parent()?.parent()?.parent()?.parent()?.parent()??null;
let parentName=dom?.find('label.globo-label')?.find('span')?.eq(0)?.text()?.trim()??'';
let checkName=$(this).parent()?.find('label')?.text()?.trim()??'';
// console.log(parentName);

window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Registration Procedure Checkbox',
      "event_label":parentName+'_'+checkName
      });

  }
  
 })


$(document).on('click','div[data-id="19045"] .submit',function(){
let email=$('input[data-type="email"]')?.val();

if(email.length>0){
email=btoa(unescape(encodeURIComponent(email)));
}else{
  email='';
}
let phoneNum=$('input[data-type="phone"]')?.val();
if(phoneNum.length>0){
 phoneNum=btoa(unescape(encodeURIComponent(phoneNum)));
}else{
 phoneNum='';
}


if($(".classic-input").eq(0).val().length<1){
  return;
}
if($(".classic-input").eq(1).val().length<1){
  return;
}
if($(".classic-input").eq(2).val().length<1){
  return;
}
if($(".classic-input").eq(3).val().length<1){
  return;
}
if($(".classic-input").eq(8).val().length<1){
  return;
}
if($(".classic-input").eq(9).val().length<1){
  return;
}
if($(".classic-input").eq(10).val().length<1){
  return;
}


if($(".classic-input").eq(12).val().length<1){
  return;
}
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
if (!emailRegex.test($(".classic-input").eq(12).val().trim())) {
   return;
}



if($('div[data-element-id="checkbox-2"]').find(".checkbox-input").is(':checked')&&$('div[data-element-id="checkbox-1"]').find(".checkbox-input").is(':checked')){
window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Registration Procedure Button',
      'Dreame_youxiang':email,
      'Dreame_dhhm':phoneNum,
      "event_label":'Contact Us'
      });
}


})



}


if(pagesUrl.indexOf("/pages/product-registration") !== -1){

$(document).on('click','.product-registration__button',function(){
window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Product Registration Button',
      "event_label":$(this)?.text()?.trim()??''
      });
})


$(document).on('blur','.product-registration__form input',function(){
let contents =$(this)?.parent()?.parent()?.parent()?.find('label')?.contents()??[];

 let title = contents.filter(function() {
return this.nodeType === 3; 
})?.text()?.trim()?.replace('*', '')??'';
// console.log(title);
if(title.length<1){
title=$(this)?.parent()?.parent()?.parent()?.parent()?.find('label')?.text()?.trim()??'';
// console.log(title);
}
window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Product Registration Input Or Select',
      "event_label":title
      });
})


$(document).on('click','.custom-select-options__inner .custom-select-option',function(){

window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Product Registration Input Or Select',
      "event_label":'Purchased From'
      });

})





$(document).on('click','.product-registration__button:nth-child(2)',function(){
 let phoneNumber=$('.product-registration__phone-number-input')?.find('input')?.val()?.trim()??'';
 if(phoneNumber.length>0){
  window.dataLayer.push({
      "event": 'Support_event',
      "event_category": 'Product Registration Button',
      "Dreame_dhhm":phoneNumber,
      "event_label":'Confirm'
      });
 }

})



}



if(pagesUrl.indexOf("/pages/robot-vacuum-and-mop-comparison") !== -1 ||pagesUrl.indexOf("/pages/vacuum-cleaner-comparison") !== -1 || pagesUrl.indexOf("/pages/wet-and-dryer-comparison") !== -1){

let event_tab='';
let item_list_compare='';
let event_compare='';
let item_list_id_compare='0';
if(pagesUrl.indexOf("/pages/robot-vacuum-and-mop-comparison") !== -1){
event_tab='Compare Robot Vacuums';
item_list_compare='Compare Robot Vacuums';
event_compare='Robot Vacuums';
item_list_id_compare="10017";
}
if(pagesUrl.indexOf("/pages/vacuum-cleaner-comparison") !== -1 ){
event_tab='Compare Vacuum Models';
item_list_compare='Compare Vacuum Models';
    event_compare='Cordless Stick Vacuums';
    item_list_id_compare="10018";
}

if(pagesUrl.indexOf("/pages/wet-and-dryer-comparison") !== -1){
event_tab='Compare Wet and Dry Vacuum Models';
item_list_compare='Compare Wet and Dry Vacuum Models';
     event_compare='Wet Dry Vacuums';
     item_list_id_compare="10019";
}
  $(document).on('click','.learn-more-btn',function(){

 let title=$(this)?.parent()?.find('.select-box-shadow')?.find('.first-cell')?.find('span')?.text()?.trim()??'';

window.dataLayer.push({
"event": 'Support_event',
"event_category":event_tab+" Button",
"event_label":'Learn More_'+title
});

})













$(document).on('click','.select-box .option-cell',function(){

let title=$(this).find('.option-cell-inner').text().trim();
window.dataLayer.push({
"event": 'Support_event',
"event_category":event_tab+" Select",
"event_label":title
});

// let dom=$(this).parent().parent().parent();

// let  Wet_compare_detail=[];
// Wet_compare_detail.push({
// "item_id":dom?.find(".home_product_id")?.val()??'',
// "item_name":dom?.find('.home_product_title')?.val()??'',
// "item_category":event_compare,
// "item_brand":"dreame",
// "price":parseFloat(parseFloat(dom?.find(".home_product_price")?.val()??0)/100).toFixed(2),
// "index":0,
// "quantity":1
// })
// if(pagesUrl.indexOf("/pages/robot-vacuum-and-mop-comparison") == -1 || pagesUrl.indexOf("/pages/vacuum-cleaner-comparison") == -1 || pagesUrl.indexOf("/pages/wet-and-dryer-comparison") == -1){
// dataLayer.push({ecommerce:null});
// window.dataLayer.push({
// "event": 'select_item',
// ecommerce:{
// "item_list_id": item_list_id_compare,
// "item_list_name":"Support_"+item_list_compare,
// "items":Wet_compare_detail
// }
// });
// }



})


if(pagesUrl.indexOf("/pages/robot-vacuum-and-mop-comparison") !== -1){
   const robot_compare_dom = document.querySelector('.section-settings-box-template--24000413663604__1649918832dfd60e4c')??null;
const robot_compare_observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;

let  robot_compare=[];
let grid_i=0;
$(".grid__item").each(function(){
if(grid_i>1&&grid_i<5){
robot_compare.push({
"item_id":$(this)?.find(".home_product_id")?.val()??'',
"item_name":$(this)?.find('.home_product_title')?.val()??'',
"item_category":event_compare,
"item_brand":"dreame",
"price":parseFloat(parseFloat($(this)?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":grid_i,
"quantity":1
})

}
grid_i++;
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": '10017',
"item_list_name":item_list_compare,
"items":robot_compare
}
});


}
});
}, {
threshold: 0.1 
});
robot_compare_observer.observe(robot_compare_dom );
}
 if(pagesUrl.indexOf("/pages/vacuum-cleaner-comparison") !== -1 ){

    const Stick_compare_dom = document.querySelector('.section-settings-box-template--24000412385652__1649918832dfd60e4c')??null;
const Stick_compare_observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;

let  Stick_compare=[];
let grid_i=0;
$(".grid__item").each(function(){
if(grid_i>1&&grid_i<5){
Stick_compare.push({
"item_id":$(this)?.find(".home_product_id")?.val()??'',
"item_name":$(this)?.find('.home_product_title')?.val()??'',
"item_category":event_compare,
"item_brand":"dreame",
"price":parseFloat(parseFloat($(this)?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":grid_i,
"quantity":1
})

}
grid_i++;
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": '10018',
"item_list_name":item_list_compare,
"items":Stick_compare
}
});


}
});
}, {
threshold: 0.1 
});
Stick_compare_observer.observe(Stick_compare_dom );
 }

 if(pagesUrl.indexOf("/pages/wet-and-dryer-comparison") !== -1){
     
const Wet_compare_dom = document.querySelector('.section-settings-box-template--24000410485108__1649918832dfd60e4c')??null;
const Wet_compare_observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;

let  Wet_compare=[];
let grid_i=0;
$(".grid__item").each(function(){
if(grid_i>1&&grid_i<5){
Wet_compare.push({
"item_id":$(this)?.find(".home_product_id")?.val()??'',
"item_name":$(this)?.find('.home_product_title')?.val()??'',
"item_category":event_compare,
"item_brand":"dreame",
"price":parseFloat(parseFloat($(this)?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":grid_i,
"quantity":1
})

}
grid_i++;
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": '10019',
"item_list_name":"Support_"+item_list_compare,
"items":Wet_compare
}
});


}
});
}, {
threshold: 0.1 
});
Wet_compare_observer.observe(Wet_compare_dom );
 }


 //点击learn more
$(document).on('click',".learn-more-btn",function(){


let dom=$(this).closest(".grid__item");
let  Wet_compare_detail=[];
Wet_compare_detail.push({
"item_id":dom?.find(".home_product_id")?.val()??'',
"item_name":dom?.find('.home_product_title')?.val()??'',
"item_category":event_compare,
"item_brand":"dreame",
"price":parseFloat(parseFloat(dom?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":0,
"quantity":1
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'select_item',
ecommerce:{
"item_list_id": item_list_id_compare,
"item_list_name":"Support_"+item_list_compare,
"items":Wet_compare_detail
}
});

})



}

//App downLoad

if(pagesUrl.indexOf("/pages/dreamehome-app-download") !== -1){

  $(document).on('click','.dreamehome-app-download-body-item-button button a',function(){
 let title=$(".dreamehome-app-download-header-system-active")?.text()?.trim();

window.dataLayer.push({
"event": 'Support_event',
"event_category":"APP Download Button",
"event_label":title
});

  })

  $(document).on('click',".dreamehome-app-download-body-item-guide a",function(){
window.dataLayer.push({
"event": 'Support_event',
"event_category":"APP Download Link",
"event_label":'Dreamehome App Guide'
});


  })

}


if(pagesUrl.indexOf("/apps/aftership") !== -1){

$(document).on('click','_19xffhy8',function(){

let ordernumber=$(".dpyoDG")?.val()??'';
let email=$(".ctA-dia")?.val()??'';
let dom=$('div[data-selected="true"]')?.find("._10xnp5g1")?.text()?.trim();


if(ordernumber?.length>0&&email?.length>0&&dom=='Order number'){
window.dataLayer.push({
"event": 'Support_event',
"event_category":"Track Order Button",
"Dreame_youxiang":btoa(unescape(encodeURIComponent(email))),
"event_label":'Order number Track'
});

}else if(dom!='Order number'){

window.dataLayer.push({
"event": 'Support_event',
"event_category":"Track Order Button",
"event_label":'Tracking number Track'
});
}
})


 const trackElement = document.querySelector('.ksPrJB')??null;


 const trackobserver = new IntersectionObserver((entries) => {
 entries.forEach(entry => {

 if (entry.isIntersecting&&entry.target.preFlag!=1) {
 entry.target.preFlag=1;

setTimeout(() => {
 let  track_detail=[];
 track_detail.push({
 "item_id":"7012106698957",
 "item_name":"Dreame L10s Ultra Robot Vacuum",
 "item_category":"Robot Vacuum",
 "item_brand":"dreame",
 "price":519.99,
 "index":0,
 "quantity":1
 })

track_detail.push({
"item_id":'8740618567885',
"item_name":'Dreame X30 Ultra Robot Vacuum',
"item_category":"Robot Vacuum",
"item_brand":"dreame",
"price":899.99,
"index":1,
"quantity":1
})

track_detail.push({
"item_id":"8820028768461",
"item_name":"Dreame X40 Ultra Robot Vacuum",
"item_category":"Robot Vacuum",
"item_brand":"dreame",
"price":1199.99,
"index":2,
"quantity":1
})


track_detail.push({
"item_id":"8731409285325",
"item_name":"Dreame Z10 Station Cordless Stick Vacuum",
"item_category":"Cordless Stick Vacuums",
"item_brand":"dreame",
"price":299.99,
"index":3,
"quantity":1
})



dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": "view_item_list",
ecommerce:{
"item_list_id": "10024",
"item_list_name":"Support_Track Order_Best Sellers",
"items":track_detail
}
});


let  track_detail1=[];
track_detail1.push({
"item_id":"8832450166989",
"item_name":"Dreame H14 Wet Dry Vacuum",
"item_category":"Wet and Dry Vacuums",
"item_brand":"dreame",
"price":599.99,
"index":4,
"quantity":1
})



dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": "view_item_list",
ecommerce:{
"item_list_id": "10024",
"item_list_name":"Support_Track Order_Best Sellers",
"items":track_detail1
}
});
}, 2500);

}
});
}, {
threshold: 0.1 
});
trackobserver.observe(trackElement);



// $(document).on('click','.ksPrJB img',function(){

// let title=$(this)?.attr('alt')?.trim()??'';

// let track_product=[];
// switch(title){
//    case "Dreame L10s Ultra Robot Vacuum":
//         track_product.push({
//         "item_id":"7012106698957",
//         "item_name":"Dreame L10s Ultra Robot Vacuum",
//         "item_category":"Robot Vacuum",
//         "item_brand":"dreame",
//         "price":519.99,
//         "index":0,
//         "quantity":1
//         })
//         break;   
//    case "Dreame X30 Ultra Robot Vacuum":
//        track_product.push({
//        "item_id":"8740618567885",
//        "item_name":"Dreame X30 Ultra Robot Vacuum",
//        "item_category":"Robot Vacuum",
//        "item_brand":"dreame",
//        "price":899.99,
//        "index":1,
//        "quantity":1
//        })
//         break; 
//    case "Dreame X40 Ultra Robot Vacuum":
//        track_product.push({
//        "item_id":"8820028768461",
//        "item_name":"Dreame X40 Ultra Robot Vacuum",
//        "item_category":"Robot Vacuum",
//        "item_brand":"dreame",
//        "price":1199.99,
//        "index":2,
//        "quantity":1
//        })
//         break; 
//    case "Dreame Z10 Station Cordless Stick Vacuum":
//        track_product.push({
//        "item_id":"8731409285325",
//        "item_name":"Dreame Z10 Station Cordless Stick Vacuum",
//        "item_category":"Cordless Stick Vacuums",
//        "item_brand":"dreame",
//        "price":299.99,
//        "index":3,
//        "quantity":1
//        })

//         break; 
//    case "Dreame H14 Wet Dry Vacuum":
//        track_product.push({
//        "item_id":"8832450166989",
//        "item_name":"Dreame H14 Wet Dry Vacuum",
//        "item_category":"Wet and Dry Vacuums",
//        "item_brand":"dreame",
//        "price":599.99,
//        "index":4,
//        "quantity":1
//        })
//         break;                     

// }
// dataLayer.push({ecommerce:null});
// window.dataLayer.push({
// "event": "select_item",
// ecommerce:{
// "item_list_id": "10024",
// "item_list_name":"Support_Track Order_Best Sellers",
// "items":track_product ||[]
// }
// });


// })


$(document).on('click','.ksPrJB button',function(){

let title=$(this)?.closest(".jQDhqG")?.find("img")?.attr('alt')?.trim()??'';
let track_product=[];
switch(title){
   case "Dreame L10s Ultra Robot Vacuum":
        track_product.push({
        "item_id":"7012106698957",
        "item_name":"Dreame L10s Ultra Robot Vacuum",
        "item_category":"Robot Vacuum",
        "item_brand":"dreame",
        "price":519.99,
        "index":0,
        "quantity":1
        })
        break;   
   case "Dreame X30 Ultra Robot Vacuum":
       track_product.push({
       "item_id":"8740618567885",
       "item_name":"Dreame X30 Ultra Robot Vacuum",
       "item_category":"Robot Vacuum",
       "item_brand":"dreame",
       "price":899.99,
       "index":1,
       "quantity":1
       })
        break; 
   case "Dreame X40 Ultra Robot Vacuum":
       track_product.push({
       "item_id":"8820028768461",
       "item_name":"Dreame X40 Ultra Robot Vacuum",
       "item_category":"Robot Vacuum",
       "item_brand":"dreame",
       "price":1199.99,
       "index":2,
       "quantity":1
       })
        break; 
   case "Dreame Z10 Station Cordless Stick Vacuum":
       track_product.push({
       "item_id":"8731409285325",
       "item_name":"Dreame Z10 Station Cordless Stick Vacuum",
       "item_category":"Cordless Stick Vacuums",
       "item_brand":"dreame",
       "price":299.99,
       "index":3,
       "quantity":1
       })

        break; 
   case "Dreame H14 Wet Dry Vacuum":
       track_product.push({
       "item_id":"8832450166989",
       "item_name":"Dreame H14 Wet Dry Vacuum",
       "item_category":"Wet and Dry Vacuums",
       "item_brand":"dreame",
       "price":599.99,
       "index":4,
       "quantity":1
       })
        break;                     


}

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": "select_item",
ecommerce:{
"item_list_id": "10024",
"item_list_name":"Support_Track Order_Best Sellers",
"items":track_product || []
}
});

})


}

//about-us
if(pagesUrl.indexOf("/pages/where-to-buy") !== -1){

$(document).on('click',".where-to-buy-container-template--24000413401460__1638167563f8632c67 .wtbcc-inner a",function(){
   
  let title=$(this)?.closest(".cell")?.find(".title")?.text()?.trim()??'';
  window.dataLayer.push({
"event": 'About_Us_event',
"event_category":"Where to Buy Banner",
"event_label":title
});
  
})

$(document).on('click','.cell-732bca35-aea4-4558-a4e0-7d87420576c7 a',function(){

window.dataLayer.push({
"event": 'About_Us_event',
"event_category":"Where to Buy Banner",
"event_label":'Target Selected Stores List'
});

})


}


if(pagesUrl.indexOf("/blogs/blog") !== -1){

  $(document).on('click','.arcticle-area article a',function(){
 let title=$(this)?.closest('article')?.find(".article-title")?.find("a")?.text()?.trim()??'';
  window.dataLayer.push({
 "event": 'About_Us_event',
"event_category":"Blogs List",
 "blog_id":stringToInt(title),
"event_label":title
});
})

}


//partner-collection
if(pagesUrl.indexOf("/pages/partner-collection") !== -1){

  $(document).on('click','.shop-now',function(){
   let title=$(this)?.closest('.channel-content')?.find('.channel-title')?.text()?.trim()??'';
   let hrefTag=$(this)?.attr('href')??'';
   let tag='';
   const match = hrefTag.match(/\.(.*?)\./);
if (match) {
    tag=match[1];
}

let rst=tag.charAt(0).toUpperCase() + tag.slice(1);
  window.dataLayer.push({
"event": 'About_Us_event',
"event_category":"Partner Collection Button",
"event_label":tag+"_"+title
});
  })

}


//dreame-membership
if(pagesUrl.indexOf("/pages/dreame-membership") !== -1){
 $(document).on('click','.member-banner-btn a',function(){

  window.dataLayer.push({
"event": 'Program_event',
"event_category":"Dreame Membership Button",
"event_label":'Log in'
});

 })

 $(document).on('click','.featured-item .btn-content a',function(){
  let name=$(this)?.text()?.replace(/>/g, '')?.trim()??'';
  let title=$(this)?.closest('.featured-item')?.find('.bigger')?.text()?.trim()??'';
  window.dataLayer.push({
"event": 'Program_event',
"event_category":"Dreame Membership Link",
"event_label":title+"_"+name
});

 })


 $(document).on('click','.featured-swiper-container-template--25560317198708__new_common_product_swiper_FP9d3q .pfi-inner .member-btn a',function(){
 let title=$(this)?.closest('.pfi-inner')?.find('.bigger')?.text()?.trim()??'';

  window.dataLayer.push({
"event": 'Program_event',
"event_category":"Dreame Membership Complete Now Link",
"event_label":'Redeem_'+title
});

 })

 $(document).on('click','.featured-swiper-container-template--25560317198708__new_common_product_swiper_FP9d3q .pfi-inner .member-btn .rules-btn',function(){
let title=$(this)?.closest('.pfi-inner')?.find('.bigger')?.text()?.trim()??'';

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Dreame Membership Complete Now Link",
"event_label":'Redeem_'+title
});

})


}


if(pagesUrl.indexOf("/pages/affiliate-program") !== -1){
 

$(document).on('click','.alliance-2024-content2 a',function(){

 let href=$(this).attr('href');

let tag='';
const match = href.match(/\.(.*?)\./);
if (match) {
tag=match[1];
}

let rst=tag.charAt(0).toUpperCase() + tag.slice(1);

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Affiliate Program sign up Button",
"event_label":rst
});


})


}

//hero-exclusive-offer
if(pagesUrl.indexOf("/pages/hero-exclusive-offer") !== -1){

$(document).on('click',".vertical-top a",function(){

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Hero Exclusive Discount Button",
"event_label":'Verify with GOVX ID.'
});


})

$(document).on('click','.common-featured-container-template--24000412090740__common_product_featured_JWEL6E a',function(){

let title=$(this)?.closest(".pfi-inner")?.find(".common-title")?.text()?.trim()??'';

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Hero Exclusive Discount Verify Button",
"event_label":title
});

})


}



if(pagesUrl.indexOf("/pages/refer-a-friend") !== -1){


  $(document).on('click','.join-page-submit-button',function(){


})

}

//buy-in-bulk
if(pagesUrl.indexOf("/pages/buy-in-bulk") !== -1){

  let buy_data_index="";
  let buy_cate_name="";
  let buy_list_name="";
  let buy_pop_1=false;
  let buy_pop_2=false;
  let buy_pop_3=false;
$(document).on('click','.buy-now',function(){

let title=$(this)?.closest('.collection-content')?.find(".collection-title")?.text()?.trim()??'';
buy_list_name="Program_Buy in Bulk_"+title;
window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Button",
"event_label":title+"_Buy Now"
});
buy_data_index=$(this).attr('data-index');
switch(buy_data_index){
  case "1": buy_cate_name="Robot Vacuums";
            break;
  case "2": buy_cate_name="Wet Dry Vacuums";
            break;
  case "3": buy_cate_name="Cordless Stick Vacuums";
            break;                    

}
if(buy_data_index!="4"){
let buy_product=[];
let buy_i=0;
$('div[data-index="'+buy_data_index+'"]').find('.swiper-slide ').each(function(){
if(buy_i<4){
buy_product.push({
"item_id":$(this)?.find(".home_product_id")?.val()??'',
"item_name":$(this)?.find('.home_product_title')?.val()??'',
"item_category":buy_cate_name,
"item_brand":"dreame",
"price":parseFloat(parseFloat($(this)?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":buy_i,
"quantity":1
})

}

buy_i++;
})


let pop_flag=false
if(buy_data_index=="1"&&!buy_pop_1){
pop_flag=true;
buy_pop_1=true;
}else if(buy_data_index=="2"&&!buy_pop_2){
pop_flag=true;
buy_pop_2=true;
}else if(buy_data_index=="3"&&!buy_pop_3){
pop_flag=true;
buy_pop_3=true;
}

if(pop_flag){
  dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": "10020",
"item_list_name":buy_list_name,
"items":buy_product
}
});
}


}

})


$(document).on('click','.learn-more',function(){
let buy_product_detail=[];
let dom=$(this).closest('.swiper-slide');
buy_product_detail.push({
"item_id":dom?.find(".home_product_id")?.val()??'',
"item_name":dom?.find('.home_product_title')?.val()??'',
"item_category":buy_cate_name,
"item_brand":"dreame",
"price":parseFloat(parseFloat(dom?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":0,
"quantity":1
})
dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'select_item',
ecommerce:{
"item_list_id": "10020",
"item_list_name":buy_list_name,
"items":buy_product_detail
}
});


})


let buy_index_i=4;


$(document).on('click','.swiper-button-next',function(){
let dom=$(this).closest('.products-swiper-container');
if(dom?.find('.swiper-slide')?.eq(buy_index_i)?.length>0){
 let buy_product_list=[];
buy_product_list.push({
"item_id":dom?.find('.swiper-slide')?.eq(buy_index_i)?.find(".home_product_id")?.val()??'',
"item_name":dom?.find('.swiper-slide')?.eq(buy_index_i)?.find('.home_product_title')?.val()??'',
"item_category":buy_cate_name,
"item_brand":"dreame",
"price":parseFloat(parseFloat(dom?.find('.swiper-slide')?.eq(buy_index_i)?.find(".home_product_price")?.val()??0)/100).toFixed(2),
"index":0,
"quantity":1
})
dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": "10020",
"item_list_name":buy_list_name,
"items":buy_product_list
}
});
}
buy_index_i++;
})


$(document).on('click','.contact-target',function(){

let title=$(this)?.closest('.collection-content')?.find(".collection-title")?.text()?.trim()??'';

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Button",
"event_label":title+"_Contact Us"
});

})


$(document).on('blur','#ContactForm input',function(){

let title=$(this).attr('placeholder');
window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Input",
"event_label":title
});
})

$(document).on('blur','#ContactForm textarea',function(){
let title=$(this).attr('placeholder');
window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Input",
"event_label":title
});

})



$(document).on('click','.contact__button button',function(){
let email=$('input[type="email"]').val();
let tel=$('input[type="tel"]').val();
if(email.length>0&&tel.length>0){
window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Button",
"Dreame_youxiang":btoa(unescape(encodeURIComponent(email))),
'Dreame_dhhm':btoa(unescape(encodeURIComponent(tel))),
"event_label":'Subscribe'
});

}

})

}

if(pagesUrl.indexOf("/pages/cooperation-opportunity") !== -1){

$(document).on('blur','#mc_embed_signup_scroll input',function(){

  let title=$(this)?.attr('placeholder')??'';
  let id=$(this).attr('id');

  if(id!="mc-embedded-subscribe"){
  window.dataLayer.push({
"event": 'Program_event',
"event_category":"Cooperation Opportunity Input",
"event_label":title
});
  }

})

$(document).on('click','#mc-embedded-subscribe',function(){
let email=$('input[type="email"]')?.val()?.trim()??'';
if(email.length<1){
  return;
}
let fname=$("#mce-FNAME")?.val()?.trim()??'';
if(fname.length<1){
  return;
}
let lname=$("#mce-LNAME")?.val()?.trim()??'';
if(lname.length<1){
  return;
}
const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
if(!emailReg.test(email)){
   return;
}
let ptUrl=$("#mce-MEDIA")?.val()?.trim()??'';



const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
if(!urlPattern.test(ptUrl)|| ptUrl.length<1){
return;
}

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Buy in Bulk Button",
"Dreame_youxiang":btoa(unescape(encodeURIComponent(email))),
"event_label":'Sign Me Up'
});
})


$(document).on('click','.large-button',function(){

window.dataLayer.push({
"event": 'Program_event',
"event_category":"Cooperation Opportunity Button",
"event_label":'Send Us An Email'
});

})


}

if(pagesUrl.indexOf("/pages/dreame-live-stream") !== -1){
$(document).on('click','.member-week-login',function(){
window.dataLayer.push({
"event": 'Live_Strem_event',
"event_category":"Top Banner Button",
"event_label":'Notify me'
});
})

const streamElement = document.querySelector('.new-common-img-layout-template--24529957519732__new_common_image_layout_jVVDxa')??null;
const streamobserver = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;
let stream_i=0;
$(".new-common-img-layout-template--24529957519732__new_common_image_layout_jVVDxa").find('.item').each(function(){
window.dataLayer.push({
"event": 'view_promotion',
"creative_name":"Live Stream_Shop By Category_Banner",
"creative_slot":'Mid_Banner_'+(stream_i+1),
"promotion_id":"10023",
"promotion_name":$(this)?.find('.title-box')?.text()?.trim()??''
});

stream_i++;
})


}
});
}, {
threshold: 0.1 
});
streamobserver.observe(streamElement);

$(document).on('click','.arrow-a',function(){
let dom=$(this).closest('.item');

let index=parseInt(dom.attr('class').split('-').pop())
window.dataLayer.push({
"event": 'select_promotion',
"creative_name":"Live Stream_Shop By Category_Banner",
"creative_slot":'Mid_Banner_'+index,
"promotion_id":"10023",
"promotion_name":dom?.find('.title-box')?.text()?.trim()??''
});
})

}

$(document).on('click','.Button__Container-f1mwm0-0.cOAUzq',function(){
    let email=$(".Input__InputCustom-sc-1brs438-2").val();

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            

    if(emailRegex.test(email)){

     $.post(
       "https://abnormal.dreametech.com/Index/index/verifyEmail", 
       { email: email},
      function(e){
        //  console.log(e);
      },
       'JSON'              
      )
window.dataLayer.push({
"event": 'Public_event',
"event_category":"Subscribe Popup",
"Dreame_youxiang":btoa(unescape(encodeURIComponent(email))),
"event_label":'Grap Now'
});


     }
})


document.addEventListener('DOMContentLoaded', function() {
  $.get(
      "https://abnormal.dreametech.com/Index/index/getUserCount", 
       function(e){
        // console.log(e);
        if(e.code!=200){
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) { 

        $(node).hide();
        
        if ($(node).hasClass('tada-widget') || $(node).is('#tadaWidget')) {
          $(node).hide();
        }

        $(node).find('.tada-widget, #tadaWidget').hide();
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
        }
       },
       'JSON'              
      )



      document.addEventListener('DOMContentLoaded', function() {

            document.addEventListener('click', function(event) {
            console.log.log(event.target.innerHTML);
            if(event.target.closest(".collection-product-feature-swiper-container .learn-more-btn")&&pagesUrl.indexOf("/pages/collection-wet-and-dry-vacuum") !== -1){
           
              let dom=event.target.closest(".grid__item");
let  more_products1=[];
const productIdInput = dom ? dom.querySelector('.home_product_id') : null;
const productNameInput = dom ? dom.querySelector(".home_product_title") : null;
const priceElement = dom ? dom.querySelector(".Price--highlight") : null;
let morePrice=0;
if(priceElement){
morePrice=parseFloat(priceElement ? priceElement.textContent.replace(/[$,]/g, '') : 0);
}else{
const priceElement = document.querySelector('.grid-product__price');

const lastTextNode = priceElement.lastChild;
if (lastTextNode.nodeType === Node.TEXT_NODE) {
morePrice = lastTextNode.textContent.trim().replace(/[$,]/g, '');
}

}

more_products1.push({
"item_id": productIdInput ? productIdInput.value.trim().toString() : '',
"item_name": productNameInput ? productNameInput.value.trim() : '',
"item_category":"Wet Dry Vacuums",
"item_brand":"dreame",
"price":parseFloat(morePrice),
"index":0,
"quantity":1
})

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'select_item',
ecommerce:{
"item_list_id": "10011",
"item_list_name":'Category_Wet Dry Vacuums',
"items":more_products1
}
});



            }
            let tagName=event.target?.tagName?.trim()??'';
            // console.log(tagName);
            if(tagName=='CUSTOM-SELECT-OPTION'){

            let title=event.target?.textContent?.trim()??'';
            if(title.length<1){
               title="Phone Number";
            }else{
               title="Purchased From";
            }
            window.dataLayer.push({
                "event": 'Support_event',
                "event_category": 'Product Registration Input Or Select',
                "event_label":title
            });

          }

          if(tagName=='SPAN'&& pagesUrl.indexOf("/pages/product-registration") !== -1){
            window.dataLayer.push({
                "event": 'Support_event',
                "event_category": 'Product Registration Input Or Select',
                "event_label":'Phone Number'
            });

          }

          if(event.target.closest(".jQDhqG img")){

           
         let title=event.target.getAttribute("alt");
let track_product=[];

switch(title){
   case "Dreame L10s Ultra Robot Vacuum":
        track_product.push({
        "item_id":"7012106698957",
        "item_name":"Dreame L10s Ultra Robot Vacuum",
        "item_category":"Robot Vacuum",
        "item_brand":"dreame",
        "price":519.99,
        "index":0,
        "quantity":1
        })
        break;   
   case "Dreame X30 Ultra Robot Vacuum":
       track_product.push({
       "item_id":"8740618567885",
       "item_name":"Dreame X30 Ultra Robot Vacuum",
       "item_category":"Robot Vacuum",
       "item_brand":"dreame",
       "price":899.99,
       "index":1,
       "quantity":1
       })
        break; 
   case "Dreame X40 Ultra Robot Vacuum":
       track_product.push({
       "item_id":"8820028768461",
       "item_name":"Dreame X40 Ultra Robot Vacuum",
       "item_category":"Robot Vacuum",
       "item_brand":"dreame",
       "price":1199.99,
       "index":2,
       "quantity":1
       })
        break; 
   case "Dreame Z10 Station Cordless Stick Vacuum":
       track_product.push({
       "item_id":"8731409285325",
       "item_name":"Dreame Z10 Station Cordless Stick Vacuum",
       "item_category":"Cordless Stick Vacuums",
       "item_brand":"dreame",
       "price":299.99,
       "index":3,
       "quantity":1
       })

        break; 
   case "Dreame H14 Wet Dry Vacuum":
       track_product.push({
       "item_id":"8832450166989",
       "item_name":"Dreame H14 Wet Dry Vacuum",
       "item_category":"Wet and Dry Vacuums",
       "item_brand":"dreame",
       "price":599.99,
       "index":4,
       "quantity":1
       })
        break;                     


}

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": "select_item",
ecommerce:{
"item_list_id": "10024",
"item_list_name":"Support_Track Order_Best Sellers",
"items":track_product || []
}
});

          }

if(event.target.closest('.shopify-payment-button__button')&&pagesUrl.indexOf("/products/") !== -1){
let productName=$(".home_product_title")?.val()??'';
if(productName.length>0){
window.dataLayer.push({
"event": 'Product_Detail_event',
"event_category": productName+'Button',
"event_label":'Buy It Now'
});
}

}


if(event.target.closest('.btn--add-to-cart')){

window.dataLayer.push({
"event": 'Public_event',
"event_category": 'Impression',
"event_label":'Cart Popup'
});

}

if(event.target.closest('.link-btn')&&pagesUrl.indexOf("/pages/collection-wet-and-dry-vacuum") !== -1){
window.dataLayer.push({
"event": 'Category_event',
"Category_event": 'Wet Dry Vacuums Top Banner Button',
"event_label":'SHOP NOW'
});

}

if(event.target.closest('.swiper-slide-1 button[data-index="3"]')&&pagesUrl.indexOf("/pages/collection-wet-and-dry-vacuum") !== -1){

 window.dataLayer.push({
"event": 'Category_event',
"Category_event": 'Wet Dry Vacuums Top Banner Button',
"event_label":'COMPARE MODELS'
});
}


if(event.target.closest(".jQDhqG button")){

let title1=event.target?.closest(".jQDhqG")?.querySelector("img")?.getAttribute("alt")??"";
let track_product1=[];
// console.log(title1);
switch(title1){
case "Dreame L10s Ultra Robot Vacuum":
track_product1.push({
"item_id":"7012106698957",
"item_name":"Dreame L10s Ultra Robot Vacuum",
"item_category":"Robot Vacuum",
"item_brand":"dreame",
"price":519.99,
"index":0,
"quantity":1
})
break;
case "Dreame X30 Ultra Robot Vacuum":
track_product1.push({
"item_id":"8740618567885",
"item_name":"Dreame X30 Ultra Robot Vacuum",
"item_category":"Robot Vacuum",
"item_brand":"dreame",
"price":899.99,
"index":1,
"quantity":1
})
break;
case "Dreame X40 Ultra Robot Vacuum":
track_product1.push({
"item_id":"8820028768461",
"item_name":"Dreame X40 Ultra Robot Vacuum",
"item_category":"Robot Vacuum",
"item_brand":"dreame",
"price":1199.99,
"index":2,
"quantity":1
})
break;
case "Dreame Z10 Station Cordless Stick Vacuum":
track_product1.push({
"item_id":"8731409285325",
"item_name":"Dreame Z10 Station Cordless Stick Vacuum",
"item_category":"Cordless Stick Vacuums",
"item_brand":"dreame",
"price":299.99,
"index":3,
"quantity":1
})

break;
case "Dreame H14 Wet Dry Vacuum":
track_product1.push({
"item_id":"8832450166989",
"item_name":"Dreame H14 Wet Dry Vacuum",
"item_category":"Wet and Dry Vacuums",
"item_brand":"dreame",
"price":599.99,
"index":4,
"quantity":1
})
break;


}

dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": "select_item",
ecommerce:{
"item_list_id": "10024",
"item_list_name":"Support_Track Order_Best Sellers",
"items":track_product1 || []
}
});



}
if(event.target.textContent.trim()  == 'Track'){
let trackOrdernumber=$('div[aria-label="Order Lookup"]')?.find('input')?.eq(0)?.val()??'';
let trackEmail=$('div[aria-label="Order Lookup"]')?.find('input')?.eq(1)?.val()??'';

let trackDom=$('div[data-selected="true"]')?.find("._10xnp5g1")?.text()?.trim()??'';

if(trackOrdernumber.length>0&&trackEmail.length>0){

window.dataLayer.push({
"event": 'Support_event',
"event_category":"Track Order Button",
"Dreame_youxiang":btoa(unescape(encodeURIComponent(trackEmail))),
"event_label":'Order number Track'
});

}else if(trackOrdernumber.length>0){

window.dataLayer.push({
"event": 'Support_event',
"event_category":"Track Order Button",
"event_label":'Tracking number Track'
});
}
          }
            }, true)
        })
});


$(document).on('click','.featured-swiper-container-template--24777808183668__new_common_product_swiper_mRMDsdadajX .link-btn',function(){

let text_title=$(this)?.text()?.trim();
if(text_title=='SHOP NOW'){
window.dataLayer.push({
"event": 'Category_event',
"Category_event": 'Wet Dry Vacuums Top Banner Button',
"event_label":'SHOP NOW'
});
}else{
  window.dataLayer.push({
"event": 'Category_event',
"Category_event": 'Wet Dry Vacuums Top Banner Button',
"event_label":'COMPARE MODELS'
});
}
})


const upElement = document?.querySelector('#up-upsell-carousel')??document.body;
const upobserver = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;


window.dataLayer.push({
"event": 'Public_event',
"event_category":"Impression",
"event_label":"You'll love these"
});


}
});
}, {
threshold: 0.5 
});
upobserver.observe(upElement);


const a_Element = document?.querySelector('#shopify-section-template--24000416317812__common_media_video_8WqygJ')??document.body;
const a_observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
entry.target.preFlag=1;

window.dataLayer.push({
"event": 'Home_event',
"event_category":"Impression",
"event_label":"A Dream Unveiled in 2017"
});

}
});
}, {
threshold: 0.5 
});
a_observer.observe(a_Element);


if(pagesUrl.indexOf('/pages/collection-wet-and-dry-vacuum')!==-1){
const p_Element = document?.querySelector('.common-tabbar-container-overview1')??null;

const p_observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting&&entry.target.preFlag!=1) {
  entry.target.preFlag=1;
 let  wet_products1=[];
 let wet_i1=0;
  const customItemContainer = document.querySelector(".custom-item-container:first-child");
              if (customItemContainer) {
                  customItemContainer.querySelectorAll('.animate-js').forEach(function(item){
                      const productIdInput = item.querySelector(".home_product_id");
                      const productTitleInput = item.querySelector(".home_product_title");
                      const onSaleElement = item.querySelector('.on-sale');
                      
                      const itemId = productIdInput ? productIdInput.value.toString() : '';
              
                      const itemName = productTitleInput ? productTitleInput.value : '';
                      const price = parseFloat(onSaleElement ? onSaleElement.textContent.trim().replace(/[$,]/g, '') : 0);
                      
                      if(wet_i1<4){
                          wet_products1.push({
                              "item_id":itemId,
                              "item_name":itemName,
                              "item_category":'Wet Dry Vacuums',
                              "item_brand":"dreame",
                              "price":price,
                              "index":wet_i1,
                              "quantity":1
                          })
                      }

                      wet_i1++;
                  });
              }

              dataLayer.push({ecommerce:null});
              window.dataLayer.push({
                  "event": 'view_item_list',
                  ecommerce:{
                      "item_list_id": "10011",
                      "item_list_name":'Category_Wet Dry Vacuums',
                      "items":wet_products1
                  }
              });
  
   let  wet_products2=[];
   let  wet_products3=[];
   let wet_i2=0;
   
const customItemContainer1 = document.querySelector(".common-p-showcase-container-pc-template--24777808183668__common_product_showcase_nTFKGL");
if (customItemContainer1) {
customItemContainer1.querySelectorAll('.animate-js').forEach(function(item){
const productIdInput1 = item.querySelector(".home_product_id");
const productTitleInput1 = item.querySelector(".home_product_title");
const onSaleElement1 = item.querySelector('.on-sale');

const itemId1 = productIdInput1 ? productIdInput1.value.toString() : '';
const itemName1 = productTitleInput1 ? productTitleInput1.value : '';
const price1 = parseFloat(onSaleElement1 ? onSaleElement1.textContent.trim().replace(/[$,]/g, '') : 0);
if(wet_i2<4){
wet_products2.push({
"item_id":itemId1,
"item_name":itemName1,
"item_category":'Wet Dry Vacuums',
"item_brand":"dreame",
"price":price1,
"index":wet_i2,
"quantity":1
})
}else{

wet_products3.push({
"item_id":itemId1,
"item_name":itemName1,
"item_category":'Wet Dry Vacuums',
"item_brand":"dreame",
"price":price1,
"index":wet_i2,
"quantity":1
})
}

wet_i2++;
});
}

    dataLayer.push({ecommerce:null});
    window.dataLayer.push({
        "event": 'view_item_list',
        ecommerce:{
          "item_list_id": "10011",
          "item_list_name":'Category_Wet Dry Vacuums',
          "items":wet_products2
        }
      });

      dataLayer.push({ecommerce:null});
window.dataLayer.push({
"event": 'view_item_list',
ecommerce:{
"item_list_id": "10011",
"item_list_name":'Category_Wet Dry Vacuums',
"items":wet_products3
}
});



}
});
}, {
threshold: 0.1 
});
if(p_Element){
 p_observer.observe(p_Element);
}



const dayElement = document?.querySelector('.common-tabbar-container-overview4')??null;
const dayobserver = new IntersectionObserver((entries) => {
entries.forEach(entry => {

if (entry.isIntersecting) {
entry.target.preFlag=1;
window.dataLayer.push({
"event": 'Category_event',
"event_category": 'Impression',
"event_label":'Compare Wet and Dry Vacuum Models'
});

}
});
}, {
threshold: 0 
});
if(dayElement){
  dayobserver.observe(dayElement);
}

}




$(document).on('click','.site-nav li[data-name="christmas-sale"] a',function(){
window.dataLayer.push({
  "event":"Navigation_event",
  "event_category":"Header Primary Navigation",
  "event_label":"Christmas Sale"
})
})

$(document).on('click','.social-sharing a',function(){

let title=$(this)?.find('.visually-hidden')?.text()?.trim()??'';
let name='';
switch (title) {
  case 'Share on Facebook':
    name='Facebook';
    break;
  case 'Tweet on Twitter':
    name='Twitter';
    break;
  case 'Pin on Pinterest':
    name='Pinterest';
    break;  
}

let dom=$(this).closest("article");
let titleInt=stringToInt(dom?.find('header')?.find('h1')?.text()?.trim()??'');

window.dataLayer.push({
"event": 'About_Us_event',
"event_category":"Blog Detail",
"blog_id":titleInt,
"event_label":name
});

})


$(document).on('click',".grid__item .collection-link div a",function(){
let title=$(this)?.text()?.trim()??'';
  window.dataLayer.push({
"event": 'Support_event',
"event_category": 'Compare Models Tab',
"event_label":title
});
})





function stringToInt(str) {
let hash = 0;
for (let i = 0; i < str.length; i++) {
hash = ((hash << 5) - hash) + str.charCodeAt(i);
hash = hash & hash; 
}
return Math.abs(hash).toString();
}



})


